export const ADD_REVIEW_LOCATION = 'add_review_location';
